import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class CSVEntityItem<
  ID extends Lowercase<string>,
  ClassType extends string,
  QueryParameter extends string
> extends ComplexEnumItem<ID> {
  constructor({
    id,
    classType,
    classTypeName,
    headers,
    importColumns,
    upsertKeys,
    queryParameter,
    filtered = false,
  }: Pick<
    CSVEntityItem<ID, ClassType, QueryParameter>,
    'id' | 'classType' | 'classTypeName' | 'headers' | 'queryParameter'
  > &
    Partial<
      Pick<
        CSVEntityItem<ID, ClassType, QueryParameter>,
        'filtered' | 'importColumns' | 'upsertKeys'
      >
    >) {
    super(id)
    this.classType = classType
    this.classTypeName = classTypeName
    this.headers = headers
    this.importColumns = importColumns ?? []
    this.upsertKeys = upsertKeys ?? []
    this.queryParameter = queryParameter
    this.filtered = filtered
  }
  /**
   * the server-side class type associated with the CSV's primary entity
   *
   * @example 'PayItemNoGeometry'
   * @example 'ConstructionAdminSubmittal'
   * @example 'DailyInspectionInspection'
   */
  readonly classType: ClassType
  /**
   * the "human readable" version of {@link classType}
   *
   * @example 'Pay Item'
   * @example 'Construction & Admin Submittal'
   * @example 'Inspection'
   */
  readonly classTypeName: string
  /**
   * a list of all possible headers that will be included in the CSV export
   */
  readonly headers: string[]

  /**
   * a list of column names that are allowed to be imported from the CSV.
   */
  readonly importColumns: string[]

  /**
   * a list of column names that are allowed to be used as upsert keys for CSV imports.
   */
  readonly upsertKeys: string[]

  /**
   * the query parameter needed to reference the correct CSV at /:projectId/csv?entity=
   */
  readonly queryParameter: QueryParameter
  /**
   * whether deleted records are included in the results
   *
   * @default false
   * @deprecated we need to care about this for legacy, but we also need to draw a line in the sand as to whether we always return soft deleted or not
   */
  readonly filtered: boolean
}
